import React, { useEffect, useState } from 'react';
import Icon from '../../../components/AppIcon';
import { formatINR } from '../../../data/games';

const RECENT_WINNERS = [
  { id: 1, name: 'Rahul K.', city: 'Jaipur', amount: 124500, game: 'Teen Patti Gold', time: '2 min ago' },
  { id: 2, name: 'Priya S.', city: 'Delhi NCR', amount: 78000, game: 'Andar Bahar Royal', time: '5 min ago' },
  { id: 3, name: 'Imran A.', city: 'Hyderabad', amount: 210000, game: 'Dragon Tiger', time: '8 min ago' },
  { id: 4, name: 'Meera J.', city: 'Pune', amount: 46800, game: 'Lightning Roulette', time: '12 min ago' },
  { id: 5, name: 'Vikash M.', city: 'Lucknow', amount: 89000, game: 'Blackjack Premium', time: '15 min ago' },
  { id: 6, name: 'Anjali R.', city: 'Kolkata', amount: 315000, game: 'Rocket Crash', time: '19 min ago' },
];

const SocialProofMetrics = () => {
  const [metrics, setMetrics] = useState({
    activePlayers: 8547,
    todayWinnings: 23000000,
    winnersThisHour: 156,
    totalWinnings: 1200000000,
    happyPlayers: 10000,
    avgRating: 4.9,
  });
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const m = setInterval(() => {
      setMetrics((p) => ({
        ...p,
        activePlayers: p.activePlayers + Math.floor(Math.random() * 24) - 11,
        todayWinnings: p.todayWinnings + Math.floor(Math.random() * 60000),
        winnersThisHour: p.winnersThisHour + (Math.random() > 0.6 ? 1 : 0),
      }));
    }, 5000);
    const w = setInterval(() => setIndex((i) => (i + 1) % RECENT_WINNERS.length), 3000);
    return () => {
      clearInterval(m);
      clearInterval(w);
    };
  }, []);

  const live = [
    { id: 1, icon: 'Users', label: 'Players online', value: metrics.activePlayers.toLocaleString('en-IN'), color: '#5B8CFF', trend: '+12%' },
    { id: 2, icon: 'TrendingUp', label: "Today's winnings", value: formatINR(metrics.todayWinnings), color: '#25D366', trend: '+8%' },
    { id: 3, icon: 'Trophy', label: 'Winners this hour', value: `${metrics.winnersThisHour}`, color: '#F0C24B', trend: '+15%' },
    { id: 4, icon: 'Star', label: 'Player rating', value: `${metrics.avgRating}★`, color: '#FF8ED0', trend: 'Excellent' },
  ];

  return (
    <section className="relative overflow-hidden border-y border-white/8 bg-[#07070E]/80 py-20">
      <span className="aurora left-1/2 top-0 h-72 w-[36rem] -translate-x-1/2 bg-royal-gold/15" aria-hidden="true" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Live metrics */}
        <div className="perspective grid grid-cols-2 gap-4 lg:grid-cols-4">
          {live.map((m) => (
            <div key={m.id} className="stat-3d">
              <span
                className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10"
                style={{ background: `${m.color}1F` }}
              >
                <Icon name={m.icon} size={22} color={m.color} />
              </span>
              <div className="font-display text-2xl font-bold text-white tabular-nums">{m.value}</div>
              <div className="mt-1 text-xs text-white/45">{m.label}</div>
              <div className="mt-2 inline-flex items-center gap-1 rounded-full bg-wa-green/12 px-2 py-0.5 text-[0.62rem] font-semibold text-wa-green">
                <Icon name="ArrowUpRight" size={10} /> {m.trend}
              </div>
            </div>
          ))}
        </div>

        {/* Winner ticker */}
        <div className="panel-gold mt-10 overflow-hidden p-6">
          <div className="mb-4 flex items-center justify-between">
            <span className="flex items-center gap-2 font-display text-sm font-semibold uppercase tracking-[0.18em] text-wa-green">
              <span className="relative flex h-2.5 w-2.5">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-wa-green opacity-75" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-wa-green" />
              </span>
              Live payouts
            </span>
            <span className="text-xs text-white/40">Streaming from the cashier desk</span>
          </div>

          <div className="relative h-[4.5rem] overflow-hidden">
            <div
              className="absolute inset-x-0 transition-transform duration-700 ease-royal"
              style={{ transform: `translateY(-${index * 4.5}rem)` }}
            >
              {RECENT_WINNERS.map((w) => (
                <div key={w.id} className="flex h-[4.5rem] items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gradient-to-br from-[#FFF0B8] to-[#C4901A] font-display text-sm font-bold text-[#150F02]">
                      {w.name.charAt(0)}
                    </span>
                    <div>
                      <p className="font-display text-sm font-semibold text-white">{w.name}</p>
                      <p className="text-xs text-white/45">{w.city} · {w.game}</p>
                    </div>
                  </div>
                  <div className="text-right">
                    <p className="font-display text-xl font-bold text-wa-green">+{formatINR(w.amount)}</p>
                    <p className="text-[0.68rem] text-white/35">{w.time}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Pillars */}
        <div className="perspective mt-10 grid gap-6 md:grid-cols-3">
          {[
            { icon: 'ShieldCheck', color: '#25D366', title: '100% secure', copy: 'Bank-grade encryption on every deposit, session and withdrawal.' },
            { icon: 'Zap', color: '#5B8CFF', title: '5 minute payouts', copy: 'UPI, wallets and net banking — cleared while you are still online.' },
            { icon: 'MessageCircle', color: '#F0C24B', title: '24×7 human desk', copy: 'A real person on WhatsApp at 3am, not a chatbot loop.' },
          ].map((c) => (
            <div key={c.title} className="card-3d p-7 text-center">
              <span
                className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl"
                style={{ background: `${c.color}1F` }}
              >
                <Icon name={c.icon} size={26} color={c.color} />
              </span>
              <div className="font-heading text-xl font-bold text-white">{c.title}</div>
              <p className="mt-2 text-sm text-white/50">{c.copy}</p>
            </div>
          ))}
        </div>

        {/* Lifetime numbers */}
        <div className="card-flat mt-10 grid grid-cols-2 gap-6 p-8 md:grid-cols-4">
          {[
            { v: formatINR(metrics.totalWinnings), l: 'Total winnings paid' },
            { v: `${metrics.happyPlayers.toLocaleString('en-IN')}+`, l: 'Happy players' },
            { v: '3 Years', l: 'Trusted service' },
            { v: '50+', l: 'Premium games' },
          ].map((s) => (
            <div key={s.l} className="text-center">
              <div className="font-display text-2xl font-bold gold-text sm:text-3xl">{s.v}</div>
              <div className="mt-1 text-xs uppercase tracking-[0.14em] text-white/45">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialProofMetrics;
